import { render, staticRenderFns } from "./ManufacturingFinanceSettings.vue?vue&type=template&id=a971c196&scoped=true&"
import script from "./ManufacturingFinanceSettings.vue?vue&type=script&lang=js&"
export * from "./ManufacturingFinanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a971c196",
  null
  
)

export default component.exports